var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42847 5.71436L9.9999 9.28578M9.9999 9.28578L13.5713 5.71436M9.9999 9.28578V0.714355",
    stroke: "#808191",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 6.42871C17.5216 6.42871 17.885 6.57922 18.1529 6.84713C18.4208 7.11504 18.5713 7.4784 18.5713 7.85728V17.8573C18.5713 18.2362 18.4208 18.5995 18.1529 18.8674C17.885 19.1353 17.5216 19.2859 17.1428 19.2859H2.85704C2.47816 19.2859 2.11479 19.1353 1.84689 18.8674C1.57898 18.5995 1.42847 18.2362 1.42847 17.8573V7.85728C1.42847 7.4784 1.57898 7.11504 1.84689 6.84713C2.11479 6.57922 2.47816 6.42871 2.85704 6.42871",
    stroke: "#808191",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42847 8.22876L9.99989 14.2859L18.5713 8.22876",
    stroke: "#808191",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.fe98348fe8cb6305179fb3ae3d756935.svg";
export { ForwardRef as ReactComponent };